<template>
  <div class="d-flex flex-column h-100 ">
    <div>
      <b-row class="">
        <b-col>
          <template v-if="message.receiver">
            <span class="font-weight-bold mr-2">To:</span>
            <span>{{ message.receiver }}</span>
          </template>
          <template v-else>
            <span class="font-weight-bold mr-2">From:</span>
            <span>{{ message.sender }}</span>
          </template>
        </b-col>
        <b-col>
          <span class="font-weight-bold mr-2">Subject:</span>
          <span>{{ message.subject }}</span>
        </b-col>
        <b-col>
          <span class="font-weight-bold mr-2">Sent:</span>
          <span> {{ $dayjs(message.date).format('MM/DD/YYYY') }} </span>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-col cols="12">
          {{ message.body }}
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-start justify-content-md-end mt-5"
      >
        <b-button variant="v3_teal_outline" @click="$emit('close')" class="mr-4">Close</b-button>
        <b-button variant="v3_teal_outline" @click="$emit('reply')">Reply</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'MessageView',
  props: {
    message: Object,
  },
};
</script>

<style scoped></style>
